import { render, staticRenderFns } from "./look_zuoci.vue?vue&type=template&id=42acef9b&scoped=true&"
import script from "./look_zuoci.vue?vue&type=script&lang=js&"
export * from "./look_zuoci.vue?vue&type=script&lang=js&"
import style0 from "./look_zuoci.vue?vue&type=style&index=0&id=42acef9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42acef9b",
  null
  
)

export default component.exports